import { useTranslation } from 'react-i18next';
import { Card, CardContent, Text } from '@shared/ui';

const SHADOW_STEPS = [
  { key: 'uiLibrary.tokens.shadows.none', className: 'shadow-none' },
  { key: 'uiLibrary.tokens.shadows.sm', className: 'shadow-sm' },
  { key: 'uiLibrary.tokens.shadows.md', className: 'shadow-md' },
  { key: 'uiLibrary.tokens.shadows.lg', className: 'shadow-lg' },
];

export function ShadowScale() {
  const { t } = useTranslation();
  const translate = (key: string) => t(key as never) as string;

  return (
    <Card>
      <CardContent className="flex flex-wrap gap-4 p-6">
        {SHADOW_STEPS.map((shadow) => (
          <div key={shadow.key} className="flex flex-col items-center gap-2">
            <div
              className={`h-12 w-16 rounded-md border border-border bg-card ${shadow.className}`}
            />
            <Text size="xs" color="muted">
              {translate(shadow.key)}
            </Text>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
